// extracted by mini-css-extract-plugin
export default {"mn-home-category-tags":"index_mn-home-category-tags__RvSDz"};